const isFunction=value=>"function"==typeof value;export{isFunction};